import { Radio } from "@mui/material";
import { withStyles } from "@mui/styles";

const StyledRadio = withStyles({
  root: {
    color: "#003399",
    "&$checked": {
      color: "#003399",
    },
  },
  checked: {
    color: "#003399",
  },
})(Radio);

export default StyledRadio;
